/** Общие кусочки карточек сущности (боковая панель): блок с заголовком, скелетон, «и ещё N»,
 *  «нет начислений». */
import React from "react";

import type { OzTree } from "@/api/ozonAnalytics";

export function Block({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <section className="space-y-2">
      <h3 className="text-sm font-medium">{title}</h3>
      {children}
    </section>
  );
}

export function Skeleton({ rows }: { rows: number }): React.ReactElement {
  return (
    <div className="space-y-2" data-testid="block-skeleton">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="h-8 animate-pulse rounded bg-muted" />
      ))}
    </div>
  );
}

/** «и ещё N» под топом блока; `shown` — сколько строк показано (по умолчанию — все пришедшие). */
export function More({
  data,
  noun,
  shown = data.rows.length,
}: {
  data: OzTree;
  noun: string;
  shown?: number;
}): React.ReactElement | null {
  const rest = data.total_count - shown;
  if (rest <= 0) return null;
  return (
    <div className="px-2 py-1 text-xs text-muted-foreground">
      и ещё {rest} {noun}
    </div>
  );
}

export function Empty(): React.ReactElement {
  return <div className="text-xs text-muted-foreground">Нет начислений в периоде.</div>;
}
